import { application } from './application'
import StimulusControllerResolver, { createViteGlobResolver } from 'stimulus-controller-resolver'


StimulusControllerResolver.install(application, createViteGlobResolver(
  import.meta.glob('./**/*_controller.js'),
  import.meta.glob('./../../components/**/*_controller.js')
))
